var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.878,
    height: 27.878,
    viewBox: "0 0 27.878 27.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_document-text",
    "data-name": "vuesax/bulk/document-text",
    transform: "translate(-172 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text",
    transform: "translate(172 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.908,9.513H17.551a5,5,0,0,1-4.995-4.995V1.162A1.165,1.165,0,0,0,11.4,0H6.47A6.13,6.13,0,0,0,0,6.47V16.762a6.13,6.13,0,0,0,6.47,6.47H15.6a6.13,6.13,0,0,0,6.47-6.47V10.675A1.165,1.165,0,0,0,20.908,9.513Z",
    transform: "translate(2.904 2.323)",
    fill: "#191919",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.3.226A.759.759,0,0,0,0,.737V4.791a3.167,3.167,0,0,0,3.194,3.1C4.3,7.9,5.831,7.9,7.144,7.9A.733.733,0,0,0,7.69,6.661C6.017,4.977,3.02,1.945,1.3.226Z",
    transform: "translate(17.052 2.341)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M7.841,1.742H.871A.878.878,0,0,1,0,.871.878.878,0,0,1,.871,0H7.841a.878.878,0,0,1,.871.871A.878.878,0,0,1,7.841,1.742Z",
    transform: "translate(7.841 14.229)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M5.518,1.742H.871A.878.878,0,0,1,0,.871.878.878,0,0,1,.871,0H5.518a.878.878,0,0,1,.871.871A.878.878,0,0,1,5.518,1.742Z",
    transform: "translate(7.841 18.876)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H27.878V27.878H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.6d3da760bdde63633b72bc3e5b495afc.svg";
export { ForwardRef as ReactComponent };